import "./pageWrapper.css";

const PageWrapper = ({ children }) => (
  <div className="page-fade">{children}</div>
);

export default PageWrapper;